import { db } from 'firebase/index'
import { getConverter } from 'lib/firestore'
import { CouponType } from 'types/coupon'
import { CouponUserType } from 'types/coupon_user'

const CouponConverter = getConverter<CouponType>()
const CouponUserConverter = getConverter<CouponUserType>()

export const fetchCoupon = (couponId: string): Promise<CouponType | undefined> => {
  return db
    .collection('coupons')
    .doc(couponId)
    .withConverter(CouponConverter)
    .get()
    .then((snapshot) => {
      return snapshot.data()
    })
    .catch((error) => {
      console.error(error)
      return undefined
    })
}

export const fetchCouponUsers = (couponId: string): Promise<CouponUserType[]> => {
  return db
    .collection('coupons')
    .doc(couponId)
    .collection('coupon_users')
    .withConverter(CouponUserConverter)
    .orderBy('created_at', 'desc')
    .get()
    .then((snapshots) => {
      return snapshots.docs.map((snapshot) => {
        return snapshot.data()
      })
    })
    .catch((error) => {
      console.error(error)
      return []
    })
}
